export const DEFAULT_ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/030dc4bf6c22a277a96c6164a1e0ef43-1720006461418/jtbd_order_updates.png';
